webpackJsonp([94934183948772],{

/***/ 2078:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"UpdateAppointmentPositionsResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"message","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":"Result of update appointment positions","isDeprecated":false,"name":"success","type":{"kind":"SCALAR","name":"Boolean","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-update-appointment-positions-result-835c6ba6f4a4780492f9.js